import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";
import { Box, Grid } from "@mui/material";
import axios from "axios";
import Percent from "components/Percent/Percent";
import { apiUrl } from "features/configure";
import React, { useContext, useEffect, useState, useMemo } from "react";
import { useOutletContext } from "react-router";
import { KeyMatrixContext } from "../context/KeyMatrixProvider";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useIntl } from "react-intl";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";

export default function MatrixStats({ dynamicEntityName, dynamicApiUrl }) {
  const [trackingStats, setTrackingStats] = useState();
  const [entityName] = useOutletContext();
  const { granularity, range, isLoading, setIsLoading } =
    useContext(KeyMatrixContext);
  const dispatchSnackbar = useDispatchSnackbar();
  const { formatMessage } = useIntl();
  async function fetchTrackingStats() {
    try {
      setIsLoading((prev) => ({ ...prev, matrixStats: true }));
      const { data } = await axios.post(
        `${apiUrl}/${dynamicApiUrl}/dashboard/${dynamicEntityName}/trackingStats`,
        {
          granularity,
          range,
        }
      );
      setTrackingStats(data);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading((prev) => ({ ...prev, matrixStats: false }));
    }
  }
  useEffect(() => {
    fetchTrackingStats();
  }, [granularity, range]);

  const stats = [
    {
      title: formatMessage({ id: "global.metrics.session" }),
      tooltip: formatMessage({ id: "metrics.session.tooltip" }),
      value: trackingStats?.sessionCount,
      growth: trackingStats?.sessionGrowth,
    },
    {
      title: formatMessage({ id: "global.metrics.uniqueWallet" }),
      tooltip: formatMessage({ id: "metrics.uniqueWallet.tooltip" }),
      value: trackingStats?.uniqueWalletCount,
      growth: trackingStats?.uniqueWalletGrowth,
    },
    {
      title: formatMessage({ id: "global.metrics.newWallet" }),
      tooltip: formatMessage({ id: "metrics.newWallet.tooltip" }),
      value: trackingStats?.newWalletCount,
      growth: trackingStats?.newWalletGrowth,
    },
    {
      title: formatMessage({ id: "global.metrics.objAchieved" }),
      tooltip: formatMessage({ id: "metrics.objAchieved.tooltip" }),
      value: trackingStats?.objectiveAchieved,
      growth: trackingStats?.objectiveAchievedGrowth,
    },
    {
      title: formatMessage({ id: "global.metrics.conversionRate" }),
      tooltip: formatMessage({ id: "metrics.conversionRate.tooltip" }),
      value: trackingStats?.convertionRate,
      growth: trackingStats?.convertionRateGrowth,
      format: "%",
    },
  ];

  return (
    <>
      {stats.map((stat) => (
        <Grid item xs={12} md={12 / 5} key={stat.title}>
          <Box
            bgcolor="white"
            p="16px"
            color="#555"
            borderRadius="4px"
            height="100%"
          >
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              height="100%"
            >
              <Box className="item-flex" mb="8px">
                <Box fontSize={16} mr="4px">
                  {stat.title}
                </Box>
                <IconTooltip content={stat.tooltip} />
              </Box>
              <Box
                display="flex"
                alignItems="flex-end"
                justifyContent={"space-between"}
              >
                {isLoading.matrixStats ? (
                  <StyledSkeleton
                    animation="wave"
                    sx={{ height: "24px", width: "80%" }}
                  />
                ) : (
                  <>
                    <Box fontSize={24} fontWeight={700}>
                      {stat?.value?.toLocaleString()}
                      {stat?.format}
                    </Box>
                    <Percent
                      data={
                        stat?.growth === "-" ? "-" : stat?.growth?.toFixed(0)
                      }
                    />
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      ))}
    </>
  );
}
